import React, {useEffect} from 'react'
import Seo from './Seo'
import PHImg from '../assets/images/Term-of-Use-Banner.png'
import {Row, Col, Container} from 'reactstrap'
import { Link } from 'react-router-dom'
import Footer from './footer'
 
export default function Termofuse() {

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'Terms of Use | Agilus Technologies'
      }, []);
  return (
    <>
      <Seo
        title="Terms of Use"
        description="Read the terms of use for the Agilus Technologies website and services."
        path="/termofuse"
      />
       {/* hero section */}
 
       <section className='custom-margin-for-header'>
            <img src={PHImg} className='img-fluid'/>
        </section>
 
        {/* hero section */}
        <section className='ce-hero-section pt-5'>
            <Container >
                <Row>
                    <Col sm={12} className='text-center mb-3'><h1 className='inter-normal'>Terms of Use</h1></Col>
                <Col sm={12} className='align-content'>
                   
                    <p className='mb-3 inter-normal'>Please read the following terms carefully as they govern your use of our website and its content, signifying your agreement to be bound by these conditions. By accessing and using <a href='https://agilustech.in/'>www.agilustech.in</a>, you agree to abide by the following terms and conditions.</p>
                   
                </Col>
               
               
                </Row>
            </Container>
 
        </section>
        {/* hero section */}
        <section className='ce-hero-section inter-normal pt-3'>
            <Container >
                <Row>
                    <Col sm={12} className='mb-3'><h2>Information</h2></Col>
                <Col sm={12} className='align-content'>
                   
                    <p className='mb-3 '>Information
 
All the information (news stories, case studies, resources, brochures, testimonials, text, photographs, images, illustrations, profiles, audio clips, video clips, trademarks, service marks and the like); this all information is protected by the copyright and intellectual property laws as applicable.</p>
                   
                </Col>
               
               
                </Row>
            </Container>
 
        </section>
        {/* hero section */}
        <section className='ce-hero-section inter-normal pt-3'>
            <Container >
                <Row>
                    <Col sm={12} className='mb-3'><h3>Liability & Indemnification</h3></Col>
                <Col sm={12} className='align-content'>
                   
                    <p className='mb-3 inter-normal'>Agilus Technologies Pvt. Ltd. will not be liable for any damages caused by any act or omission of the Agilus Technologies website or other websites linked to our website, including without limitation, any failure of performance, error, interruption, inaccuracy, and delay in operation of transmission, computer virus, or broken connection.</p>
                   
                </Col>
               
               
                </Row>
            </Container>
 
        </section>
        {/* hero section */}
        <section className='ce-hero-section inter-normal pt-3'>
            <Container >
                <Row>
                    <Col sm={12} className='text-center mb-3'><h1 className='inter-normal'>Copyright and Trademarks</h1></Col>
                <Col sm={12} className='align-content'>
                   
                    <p className='mb-3 inter-normal'>Agilus Technologies Pvt. Ltd. trademarks, logo of its subsidiaries and its service names displayed on the site are registered and unregistered Trademarks of Agilus Technologies Pvt. Ltd. Other product, service and company names mentioned on this Site may be trademarks and/or service marks of their respective owners. Agilus Technologies Pvt. Ltd. does not grant any rights to use any such marks and hereby reserves all rights related thereto. Certain portions of the Site are identified as being the subject of a specific copyright held by an entity other than Agilus Technologies Pvt. Ltd. and, as such, may not be copied without the permission of the holder of the copyright.</p>
                   
                </Col>
               
               
                </Row>
            </Container>
 
        </section>
        {/* hero section */}
        <section className='ce-hero-section inter-normal pt-3'>
            <Container >
                <Row>
                    <Col sm={12} className='mb-3'><h2>Security</h2></Col>
                <Col sm={12} className='align-content'>
                   
                    <p className='mb-3 inter-normal'>Agilus Technologies is committed to protecting the information provided by visitors. Agilus Technologies has in place reasonable physical and managerial procedures to safeguard the information we collect. Access to personal data is restricted to those employees who have a need to use the data and who have been trained to handle such data properly and observe strict standards of confidentiality.</p>
                   
                </Col>
               
               
                </Row>
            </Container>
 
        </section>
        {/* hero section */}
        <section className='ce-hero-section inter-normal pt-3'>
            <Container >
                <Row>
                    <Col sm={12} className='mb-3'><h2>Query Forms</h2></Col>
                <Col sm={12} className='align-content'>
                   
                    <p className='mb-3 inter-normal'>At some places in this website you would be asked to fill the query forms to generate response or invoke more information from the different company sections. It is the user's choice to use the forms and fill their details. These forms will allow us to provide you the information and assistance you require. The response/revert on these forms is at the sole discretion of their respective section-master. The response to a message depends on its authenticity and use- fullness.</p>
                   
                </Col>
               
               
                </Row>
            </Container>
 
        </section>
        {/* hero section */}
        <section className='ce-hero-section inter-normal pt-3'>
            <Container >
                <Row>
                    <Col sm={12} className='text-center mb-3'><h1>Privacy Statement</h1></Col>
                <Col sm={12} className='align-content'>
                   
                    <p className='mb-3 inter-normal'><a href='https://agilustech.in/'>www.agilustech.in</a>  is designed to provide information on Agilus Technologies Pvt. Ltd. Access and use of the website is subject to the disclaimer and privacy policy set forth herein and all applicable laws, statutes, and/or regulations. The following terms and conditions apply to all visitors or users of the site.</p>
                    <p className='mb-3 inter-normal'>By accessing this site, the user acknowledges acceptance of these terms and conditions. Agilus Technologies reserves the right to change these terms and conditions from time to time at its sole discretion without notice. In the case of any violation of these terms and conditions, Agilus Technologies reserves the right to seek all remedies available by law and in equity for such violations.</p>
                    <p className='mb-3 inter-normal'>Agilus Technologies may make changes to the materials and services at this Site, at any time without notice. All information is provided "as is" without warranty of any kind. In no event shall Agilus Technologies be liable for any special, indirect or consequential damages or any damages whatsoever resulting from loss of use, data or profits, arising out of or in connection with the use of the information</p>
                   
                </Col>
               
               
                </Row>
            </Container>
 
        </section>
 
        {/* footer */}
        <Footer />
    </>
  )
}